import {ListItem, ListItemText, Stack, styled} from '@mui/material';

const InfoListItem = styled(ListItem)(({theme}) => ({
	gap: theme.spacing(1),
	alignItems: 'flex-start',
}));

const InfoListItemIconStack = styled(Stack)(({theme}) => ({
	padding: theme.spacing(0.5),
}));

const InfoListItemText = styled(ListItemText)(() => ({
	margin: 0,
}));

export {InfoListItem, InfoListItemIconStack, InfoListItemText};
